'use strict';

//add drop-shadow to gobal nav on scroll
module.exports = /*@ngInject*/
function() {
    return {
        link: function(scope, element, attrs) {
            jQuery(window).scroll(function() {
                if (jQuery(this).scrollTop() > 30) {
                    jQuery('.global-nav').addClass('drop-shadow');
                } else {
                    jQuery('.global-nav').removeClass('drop-shadow');
                }
            });
        }
    };
};
